import React, { memo, useState, useMemo, useEffect, useContext } from "react";
import styled, { css } from "styled-components";
import media from "cssMix/index";
import cx from "classnames";
import { List, fromJS, Map } from "immutable";
import { ContextStore } from "Reducer";
import moment from "moment";
// comp
import { TiArrowSortedDown } from "react-icons/ti";
import SyncLoader from "react-spinners/SyncLoader";
import noIconTeamCodes from "Const/noIconTeamCodes";
// const
import CQ9VIPData from "Const/CQ9VIPData";

export default memo(
  ({
    gameList = List(),
    gameType,
    typeList,
    lang,
    t,
    handleHeartClick,
    favorite_game,
    handleOpenPopModal,
    isLoading,
    cornerTagList,
    mainAreaRoute,
    searchValue,
    isSort = true,
  }) => {
    const {
      state: { stateReducer },
    } = useContext(ContextStore);
    const [sortBy, setSortBy] = useState("default");
    const hasCQ9VIPClub = stateReducer.get("hasCQ9VIPClub");
    const [isSortPopup, setIsSortPopup] = useState(false);
    const sortOption = [
      { title: t("newToOld"), sort: 1 },
      { title: t("oldToNew"), sort: 2 },
      { title: t("hot"), sort: 3 },
    ];

    const newList = useMemo(() => {
      if (!isSort) return gameList;
      if (sortBy === "default") {
        return gameList?.sort((a, b) => {
          if (moment(b.get("present_time")).isSame(a.get("present_time")))
            return b.get("id") - a.get("id");
          return moment(b.get("present_time")) - moment(a.get("present_time"));
        });
      } else if (sortBy === 1) {
        return gameList?.sort((a, b) => {
          if (moment(b.get("present_time")).isSame(a.get("present_time")))
            return a.get("id") - b.get("id");
          return moment(b.get("present_time")) - moment(a.get("present_time"));
        });
      } else if (sortBy === 2) {
        return gameList?.sort((a, b) => {
          if (moment(a.get("present_time")).isSame(b.get("present_time")))
            return a.get("id") - b.get("id");
          return moment(a.get("present_time")) - moment(b.get("present_time"));
        });
      } else if (sortBy === 3) {
        const newList = [];
        cornerTagList.get("hot").forEach((elm) => {
          if (gameList.some((v) => v.get("game_id") === elm)) {
            newList.push(
              gameList.get(gameList.findIndex((a) => a.get("game_id") === elm))
            );
          }
        });
        return fromJS(newList);
      }
      return newList;
    }, [cornerTagList, gameList, isSort, sortBy]);

    const sortPopupHandler = () => {
      setIsSortPopup(!isSortPopup);
    };

    const sortClickHandler = (sort) => {
      setSortBy(sort);
      sortPopupHandler();
    };
    return (
      <GameWrapper>
        {mainAreaRoute === "Lobby" && (
          <div className="title-area">
            {!searchValue && (
              <div className="type-title">
                {gameType.getIn(["value", "name"]) === "allGames"
                  ? t("allGames")
                  : gameType.getIn(["value", "name"]) === "favorite"
                  ? t("myFollowedGames")
                  : gameType.getIn(["value", "name"])}
              </div>
            )}
            {!searchValue && (
              <Sort onClick={sortPopupHandler} className="gav2_btn_sequence">
                <p>
                  {sortBy === "default"
                    ? sortOption[0]["title"]
                    : sortOption[sortBy - 1]["title"]}
                </p>
                <TiArrowSortedDown />
                {isSortPopup && (
                  <>
                    <div
                      className="darkBg"
                      onClick={() => setIsSortPopup(false)}
                    />
                    <SortPopup>
                      {sortOption.map((v, i) => {
                        return (
                          <div
                            onClick={() => {
                              sortClickHandler(v["sort"]);
                            }}
                            key={i}
                          >
                            <p>{v["title"]}</p>
                          </div>
                        );
                      })}
                    </SortPopup>
                  </>
                )}
              </Sort>
            )}
          </div>
        )}
        <GamesContainer>
          <SyncLoader loading={isLoading} css={loadingIcon} />
          {fromJS(
            hasCQ9VIPClub &&
              mainAreaRoute === "Lobby" &&
              searchValue === "" &&
              gameType.get("index") === 0
              ? [CQ9VIPData]
              : []
          )
            .concat(newList)
            .map((v, i) => (
              <GameItem
                game={v}
                key={v.get("game_id")}
                typeList={typeList}
                lang={lang}
                favorite_game={favorite_game}
                cornerTagList={cornerTagList}
                handleOpenPopModal={handleOpenPopModal}
                gameType={gameType}
                searchValue={searchValue}
                t={t}
                handleHeartClick={handleHeartClick}
              />
            ))}
        </GamesContainer>
      </GameWrapper>
    );
  }
);

export const GameItem = ({
  game,
  typeList,
  lang,
  favorite_game,
  cornerTagList,
  handleOpenPopModal,
  t,
  handleHeartClick,
}) => {
  const game_id = game.get("game_id");
  const [isFavorite, setIsFavorite] = useState(favorite_game.includes(game_id));
  const type = typeList
    .find((type) => type.get("id") === game.get("type"), null, Map())
    .getIn(["name", lang]);
  const icon = game.getIn(["icon", lang], game.getIn(["icon", "en"]));
  const backgroundHorizontal = game.getIn(["background", "horizontal", lang]);
  const backgroundVertial = game.getIn(["background", "vertical", lang]);
  const name = game.getIn(
    ["name", lang],
    game.getIn(["name", "en"], "no default name")
  );
  const maintain = game.get("maintain", false);
  const team = game.get("team", "");
  const isNoIconGame = noIconTeamCodes.includes(team);
  useEffect(() => {
    setIsFavorite(favorite_game.includes(game_id));
  }, [favorite_game, game_id]);
  return (
    <GameCard
      key={game_id}
      backgroundHorizontal={backgroundHorizontal}
      backgroundVertial={backgroundVertial}
      ga-gameid={game_id}
      className={cx({
        hot: cornerTagList.get("hot")?.includes(game_id),
        new: cornerTagList.get("new")?.includes(game_id),
      })}
      maintain={maintain}
    >
      <div
        className={`gameCardimg ${game_id === "999" && "cq9vip"}`}
        onClick={(e) =>
          !maintain &&
          handleOpenPopModal({
            game_id,
            icon,
            type,
            isFavorite,
            name,
            source: "normal",
          })
        }
      >
        {game_id !== "999" && (
          <div
            className={`${
              isFavorite
                ? "fav-btn gav2_favorite_cancel"
                : "fav-btn gav2_favorite_add"
            }`}
            onClick={(e) => {
              handleHeartClick(e, game_id, isFavorite);
              setIsFavorite(!isFavorite);
            }}
            ga-gameid={game_id}
          >
            <div
              className={cx([
                "bx bxs-heart icon",
                {
                  focus: isFavorite,
                },
              ])}
              ga-gameid={game_id}
            />
          </div>
        )}
        {maintain && (
          <div className="maintain">
            <img alt="" src={`images/maintain.png`} />
            <div className="text">{t("maintain")}</div>
          </div>
        )}
        {!isNoIconGame && game_id !== "999" && (
          <img className="gameLogo" alt="" src={icon} />
        )}
      </div>

      <div className="gameCardTitle">{name}</div>
    </GameCard>
  );
};

const Sort = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  min-width: 150px;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
  border: solid 1px rgba(130, 136, 151, 0.6);
  border-radius: 8px;
  background-color: #141620;
  cursor: pointer;
  white-space: nowrap;
  & > svg {
    color: #fff;
  }
  .darkBg {
    width: 100%;
    height: 100%;
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0);
  }
  ${media.tablet`
  min-width:120px;
  height:36px;
  `}
`;
const SortPopup = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  border: solid 1px rgba(130, 136, 151, 0.6);
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  background-color: #141620;
  overflow: hidden;
  z-index: 110;

  & > div {
    box-sizing: border-box;
    padding: 10px 10px;
    &:hover {
      background-color: #2b335a;
    }
    & > p {
      margin: 0;
    }
  }
`;

const GameWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  box-sizing: border-box;
  & .title-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  & .type-title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }
  ${media.tablet`
  & .type-title{
    font-size: 18px;
  }
  `}
`;
const GamesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-bottom: 20px;
  .loadingIcon {
  }
`;
const GameCard = styled.div`
  width: ${92 / 5}%;
  max-width: 270px;
  margin-bottom: 40px;
  position: relative;
  & .fav-btn {
    position: absolute;
    right: 12px;
    top: 12px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background-color: #fff;
    cursor: pointer;
    ${media.tablet`
  right: 8px;
  top: 8px;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  `}
    ${media.mobile`
  right: 5px;
  top: 5px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  `}
  & .icon {
      font-size: 18px;
      color: #b8c2d2;
      &.focus {
        color: #f4265a;
      }
      ${media.tablet`
      font-size: 14px;
    `}
    }
  }
  @media (min-width: 1441px) {
    &:not(:nth-of-type(5n + 5)) {
      margin-right: 2%;
    }
  }
  @media (max-width: 1440px) and (min-width: 1201px) {
    width: ${94 / 4}%;
    &:not(:nth-of-type(4n + 4)) {
      margin-right: 2%;
    }
  }
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: ${96 / 3}%;
    &:not(:nth-of-type(3n + 3)) {
      margin-right: 2%;
    }
  }
  // tablet
  @media (max-width: 1024px) and (min-width: 640px) {
    margin-bottom: 30px;
    width: ${92 / 5}%;
    &:not(:nth-of-type(5n + 5)) {
      margin-right: 2%;
    }
  }
  // mobile
  @media (max-width: 639px) {
    margin-bottom: 30px;
    width: ${96 / 3}%;
    &:not(:nth-of-type(3n + 3)) {
      margin-right: 2%;
    }
    .gameCardimg {
      height: 135px;
    }
  }
  &.hot::after {
    content: "";
    right: -10px;
    bottom: 40px;
    width: 60px;
    height: 47px;
    position: absolute;
    z-index: 4;
    background: url("images/tag_hot.png") no-repeat;
    background-size: contain;
    ${media.tablet`
      width:48px;
      height:37px;
      bottom:20px;
    `}
    ${media.mobile`
      width:40px;
      height:31px;
      bottom:20px;
    `}
  }
  &.new::before {
    content: "";
    left: -8px;
    top: -8px;
    width: 76px;
    height: 76px;
    position: absolute;
    z-index: 4;
    background: url("images/tag_new.png") no-repeat;
    background-size: contain;
    ${media.tablet`
      width:57px;
      height:57px;
      left: -6px;
      top: -6px;
    `}
    ${media.mobile`
      width:48px;
      height:48px;
      left: -5px;
      top: -5px;
    `}
  }
  .gameCardimg {
    width: 100%;
    height: 170px;
    background: url(${({ backgroundHorizontal }) => backgroundHorizontal});
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 8px;
    font-size: 18px;
    position: relative;
    cursor: pointer;
    transition: transform 1s ease;
    &:hover {
      transform: translateY(-10%);
    }
    ${({ maintain }) =>
      maintain &&
      `
        pointer-events:none;
        cursor: not-allowed;
    `}
    .maintain {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.75;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      color: #ffffff;
      z-index: 6;
      cursor: none;
      pointer-events: none;
      > img {
        width: 50px;
        height: 50px;
        margin-bottom: 16px;
      }
    }
    .gameLogo {
      width: 120px;
      height: 120px;
      ${media.tablet`
      width:95px;
      height:95px;
      `}
      ${media.mobile`
      width: 75px;
      height: 75px;
      `}
    }
    transition: all 0.3s ease-in;
    transform: scale(1);
    &.cq9vip {
      background-position: 50% 50%;
      background-size: 100% 100%;
    }
  }
  .gameCardTitle {
    color: ${({ theme }) => theme.colors["6"]};
    margin-bottom: 9px;
  }
  .gameCardType {
    font-size: 13px;
    color: ${({ theme }) => theme.colors["4"]};
    padding: 3px 10px;
    border: 1px solid ${({ theme }) => theme.colors["4"]};
    border-radius: 12.5px;
  }
  ${media.tablet`
  .gameCardimg {
      height: 160px;
      background: url(${({ backgroundVertial }) => backgroundVertial});
      margin-bottom: 8px;
      background-size: 100% 100%;
      .maintain {
        font-size: 14px;
        > img {
          width: 42px;
        }
        .text {
          padding: 0 7px;
        }
      }
      .hoverBg {
        display: none;
      }
      .heart {
        top: -7px;
        right: 7px;
      }
      &:hover {
        transform: none;
      }
    }
    .gameCardTitle {
      margin-bottom: 0;
    }
    .gameCardType {
      display: none;
    }
  `}
`;

const loadingIcon = css`
  display: block;
  margin: 0 auto;
  div:nth-of-type(1) {
    background-color: #a3997e;
  }
  div:nth-of-type(2) {
    background-color: #bca325;
  }
  div:nth-of-type(3) {
    background-color: #fbca00;
  }
`;
